<template>
  <el-form class="searchbar-wrapper">
    <el-date-picker
      class="zy-date-picker"
      :value="searchParams.date"
      @input="val => $emit('change', 'date', val)"
      @change="val => $emit('change', 'date', val)"
      type="daterange"
      range-separator="-"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00', '23:59:59']"
      clearable
    />
    <el-select
      class="control"
      :value="searchParams.type"
      @input="val => $emit('change', 'type', val)"
      @change="val => $emit('change', 'type', val)"
      clearable
      placeholder="全部数据类型"
    >
      <el-option
        v-for="(item, i) in exportTypeList"
        :key="i"
        :label="item.exportName"
        :value="item.exportType"
      ></el-option>
    </el-select>
    <el-button class="search-btn" @click="$emit('search')">查询</el-button>
  </el-form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'searchBar',
  props: {
    searchParams: {
      type: Object
    }
  },
  computed: {
    ...mapState('global', ['exportTypeList'])
  }
};
</script>

<style lang="scss" scoped>
.searchbar-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;

  .control {
    margin-right: 16px;
    width: 200px;
  }

  .zy-date-picker {
    margin-right: 16px;
  }

  .search-btn {
    height: 40px !important;
    width: 80px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }
}
</style>
